import './Loader.scss';
const Loader = () => <div className="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>

export default Loader;